"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _Icon = _interopRequireDefault(require("../Icon"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }
  return target;
};
/* eslint-disable */
var Assets = function Assets(props) {
  return /*#__PURE__*/_react["default"].createElement(_Icon["default"], _extends({
    viewBox: '0 0 463 463'
  }, props), /*#__PURE__*/_react["default"].createElement('g', null, /*#__PURE__*/_react["default"].createElement('path', {
    d: 'M431.5,80H314.784l-30.202-32.718C275.618,37.57,262.896,32,249.679,32H31.5C14.131,32,0,46.131,0,63.5v48v288    C0,416.869,14.131,431,31.5,431h400c17.369,0,31.5-14.131,31.5-31.5v-288C463,94.131,448.869,80,431.5,80z M273.56,57.456    L294.37,80h-27.586l-30.202-32.718c-0.089-0.096-0.184-0.186-0.274-0.282h13.371C258.722,47,267.427,50.811,273.56,57.456z     M201.679,47c9.043,0,17.748,3.811,23.881,10.456L246.37,80h-31.279L184.89,47.282c-0.089-0.096-0.184-0.186-0.274-0.282H201.679z     M31.5,47h118.487c9.043,0,17.747,3.811,23.881,10.456L194.678,80H31.5c-6.046,0-11.698,1.716-16.5,4.681V63.5    C15,54.402,22.402,47,31.5,47z M448,399.5c0,9.098-7.402,16.5-16.5,16.5h-400c-9.098,0-16.5-7.402-16.5-16.5v-288    c0-9.098,7.402-16.5,16.5-16.5h400c9.098,0,16.5,7.402,16.5,16.5V399.5z'
  }), /*#__PURE__*/_react["default"].createElement('path', {
    d: 'm399.5,128h-112c-8.547,0-15.5,6.953-15.5,15.5v80c0,8.547 6.953,15.5 15.5,15.5h112c8.547,0 15.5-6.953 15.5-15.5v-80c0-8.547-6.953-15.5-15.5-15.5zm.5,95.5c0,0.276-0.224,0.5-0.5,0.5h-112c-0.276,0-0.5-0.224-0.5-0.5v-80c0-0.276 0.224-0.5 0.5-0.5h112c0.276,0 0.5,0.224 0.5,0.5v80z'
  }), /*#__PURE__*/_react["default"].createElement('path', {
    d: 'm375.5,160h-64c-4.142,0-7.5,3.358-7.5,7.5s3.358,7.5 7.5,7.5h64c4.142,0 7.5-3.358 7.5-7.5s-3.358-7.5-7.5-7.5z'
  }), /*#__PURE__*/_react["default"].createElement('path', {
    d: 'm375.5,192h-64c-4.142,0-7.5,3.358-7.5,7.5s3.358,7.5 7.5,7.5h64c4.142,0 7.5-3.358 7.5-7.5s-3.358-7.5-7.5-7.5z'
  })));
};
/* eslint-enable */
var _default = Assets;
exports["default"] = _default;